import { defineLocale } from "../../registry";

const media = defineLocale({
  ru: {
    "media.title": "Медиа",
    "media.list.title": "Кадры Pick",
    "media.list.empty": "Кадров пока нет",
    "media.frame.title": "Кадр {n}",
    "media.frame.host": "Хост",
    "media.frame.size": "Размер",
    "media.frame.sizeUnknown": "не определён",
    "media.frame.hostUnknown": "не определён",
    "media.frame.image": "Изображение недоступно",
    "media.frame.cover": "Обложка",
    "media.frame.coverBadge": "Обложка Pick",
    "media.frame.moveUp": "Выше",
    "media.frame.moveDown": "Ниже",
    "media.frame.error": "Сервер не принял этот кадр",
    "media.field.alt": "Alt-текст",
    "media.field.credit": "Автор",
    "media.field.license": "Лицензия",
    "media.field.sourceUrl": "Ссылка на источник",
    "media.field.rights": "Статус прав",
    "media.field.none": "не указано",
    "media.rights.licensed": "Лицензия",
    "media.rights.permission": "Разрешение",
    "media.rights.editorial_free": "Свободное редакционное",
    "media.rights.unknown": "Неизвестно",
    "media.rights.unrecognised": "Неизвестное значение",
    "media.warning.rightsUnknown":
      "Права неизвестны: кадр блокирует публикацию",
    "media.warning.altMissing": "Нет alt-текста",
    "media.warning.coverMissing":
      "Не выбрана обложка: Pick нельзя опубликовать",
    "media.add.title": "Добавить внешний кадр",
    "media.add.hint":
      "Кадр берётся по ссылке с разрешённого хоста. Файлы консоль не загружает.",
    "media.add.hosts": "Разрешённые хосты: {hosts}",
    "media.add.hostsNone": "Список разрешённых хостов недоступен",
    "media.add.url": "Ссылка на изображение",
    "media.add.alt": "Alt-текст нового кадра",
    "media.add.credit": "Автор нового кадра",
    "media.add.license": "Лицензия нового кадра",
    "media.add.sourceUrl": "Ссылка на источник нового кадра",
    "media.add.rights": "Статус прав нового кадра",
    "media.add.submit": "Добавить кадр",
    "media.add.submitting": "Добавление…",
    "media.add.blockedDirty":
      "Сначала сохраните или отмените правки кадров: новый кадр обновит запись целиком",
    "media.add.blockedGate": "Запись сейчас недоступна",
    "media.add.offline": "Нет соединения. Проверьте сеть и повторите",
    "media.add.busy": "Предыдущая операция ещё выполняется",
    "media.add.generic": "Кадр не добавлен. Попробуйте ещё раз",
    "media.add.issue.https_required": "Нужна ссылка https",
    "media.add.issue.host_not_allowed":
      "Хоста нет среди разрешённых хостов",
    "media.add.issue.invalid": "Ссылка не подходит",
    "media.add.issue.required": "Поле обязательно",
    "media.add.issue.unreachable": "Изображение по ссылке не открывается",
    "media.add.issue.generic": "Сервер не принял ссылку",
  },
  en: {
    "media.title": "Media",
    "media.list.title": "Pick frames",
    "media.list.empty": "No frames yet",
    "media.frame.title": "Frame {n}",
    "media.frame.host": "Host",
    "media.frame.size": "Size",
    "media.frame.sizeUnknown": "not detected",
    "media.frame.hostUnknown": "not detected",
    "media.frame.image": "Image unavailable",
    "media.frame.cover": "Cover",
    "media.frame.coverBadge": "Pick cover",
    "media.frame.moveUp": "Move up",
    "media.frame.moveDown": "Move down",
    "media.frame.error": "The server did not accept this frame",
    "media.field.alt": "Alt text",
    "media.field.credit": "Credit",
    "media.field.license": "License",
    "media.field.sourceUrl": "Source URL",
    "media.field.rights": "Rights status",
    "media.field.none": "not set",
    "media.rights.licensed": "Licensed",
    "media.rights.permission": "Permission",
    "media.rights.editorial_free": "Editorial free",
    "media.rights.unknown": "Unknown",
    "media.rights.unrecognised": "Unrecognised value",
    "media.warning.rightsUnknown":
      "Rights unknown: this frame blocks publishing",
    "media.warning.altMissing": "Alt text is missing",
    "media.warning.coverMissing":
      "No cover frame is chosen: the pick cannot be published",
    "media.add.title": "Add an external frame",
    "media.add.hint":
      "The frame is taken from a link on an allowed host. The console does not upload files.",
    "media.add.hosts": "Allowed hosts: {hosts}",
    "media.add.hostsNone": "The list of allowed hosts is unavailable",
    "media.add.url": "Image URL",
    "media.add.alt": "Alt text for the new frame",
    "media.add.credit": "Credit for the new frame",
    "media.add.license": "License for the new frame",
    "media.add.sourceUrl": "Source URL for the new frame",
    "media.add.rights": "Rights status for the new frame",
    "media.add.submit": "Add frame",
    "media.add.submitting": "Adding…",
    "media.add.blockedDirty":
      "Save or discard the frame edits first: adding a frame refreshes the whole record",
    "media.add.blockedGate": "Writing is unavailable right now",
    "media.add.offline": "You are offline. Check the network and try again",
    "media.add.busy": "The previous operation is still running",
    "media.add.generic": "The frame was not added. Try again",
    "media.add.issue.https_required": "The link must use https",
    "media.add.issue.host_not_allowed":
      "The host is not on the list of allowed hosts",
    "media.add.issue.invalid": "The link is not suitable",
    "media.add.issue.required": "This field is required",
    "media.add.issue.unreachable": "The image at this link does not open",
    "media.add.issue.generic": "The server did not accept the link",
  },
});

export default media;
